import React, { useEffect, useState, useContext, } from "react";
import { Navigate } from "react-router-dom";
import SpinnerLoading from "components/SpinnerLoading";
import UserModel from "models/userModel";
import ToastMsg from "components/Toast";

function PrivateRoute({ component: RouteComponent }) {
	// const [isLoading, setIsLoading] = useState(false);
	// const [isAuthed, setIsAuthed] = useState(false);

	// const userModel = useContext(UserModel.Context);

	// const getMe = async () => {
	// 	setIsLoading(true);
	// 	const login = await userModel.getMe();
	// 	setIsLoading(false);
	// 	setIsAuthed(login);
	// };

	// useEffect(() => {
	// 	// getMe();
	// 	window.addEventListener("focus", getMe);
	// 	return () => {
	// 		window.removeEventListener("focus", getMe);
	// 	};
	// }, []);

	// if (isLoading === true) return <SpinnerLoading />;

	// if (!isAuthed && !isLoading)
	// 	return <Navigate to={{ pathname: "/" }} replace />;

	return <RouteComponent />;
}

export default PrivateRoute;
